import * as React from 'react';
import { Add, Checkmark } from '@volkswagen-onehub/icons-core';
import { styled } from '../theme-provider';
const StyledAddIcon = styled(Add).withConfig({ displayName: "StyledAddIcon", componentId: "sc-9ijgpp" }) `transition:transform 300ms ease;transform:${({ active, iconPosition }) => active && iconPosition === 'end' ? 'rotate(45deg)' : 'rotate(0)'};`;
export const Icon = ({ active, iconPosition, }) => {
    if (iconPosition === 'start' && !active)
        return React.createElement(Add, { variant: "small", ariaHidden: true });
    if (iconPosition === 'end')
        return (React.createElement(StyledAddIcon, { variant: "small", iconPosition: iconPosition, active: active, ariaHidden: true }));
    return React.createElement(Checkmark, { variant: "small", ariaHidden: true });
};
